import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SeoMetaDataHandler } from "./SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";

export abstract class SeoMetaDataHandlerDefaultSort extends SeoMetaDataHandler {
	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const defaultSortingSelected = await this.sortingOptionSelected(SortingOptions.OUR_PICKS, sortState);

		return defaultSortingSelected && this.canHandleWithDefaultSorting(filterSelectionState);
	}

	protected abstract canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean>;
}
